import { TOKEN_KEY } from '../../constants';

export const jwtDecode = (token: string) => {
  try {
    const userData = token.split('.')[1];
    return JSON.parse(atob(userData));
  } catch (err) {
    localStorage.removeItem(TOKEN_KEY);
  }
};
